import * as React from 'react';
import styles from './index.less';
import DrawRecordListModalStore from '@src/business-components/draw-record-list-modal/store';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import cx from 'classnames';

const DrawRecordListModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.drawRecordListModalRoot}>
        {/* <div className={styles.title} /> */}

        {store.recordList.length !== 0 ? (
          <div className={cx(styles.recordListTitle)}>
            <div className={cx(styles.listItem)}>时间</div>
            <div className={cx(styles.listItem)}>奖励</div>
          </div>
        ) : null}
        <div className={cx(styles.content, { [styles.contentNeedScroll]: store.recordList.length >= 9 })}>
          <div className={styles.contentBox}>
            {store.recordList.length === 0 && <div className={cx(styles.recordEmpty)}>还没有中奖记录哦~快去抽奖吧!</div>}
            {store.recordList.length !== 0 && (
              <div className={cx(styles.recordList)}>
                {store.recordList.map((item, index) => {
                  const recordDate = store.getRecordDate(item.create_time);
                  const recordName = store.getPrizeName(item.prize_id);
                  return (
                    <div key={index} className={cx(styles.recordItem)}>
                      <div className={cx(styles.itemList)}>{recordDate}</div>
                      <div className={cx(styles.itemList)}>{recordName}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <Link className={cx(styles.close)} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(DrawRecordListModal, DrawRecordListModalStore);
